import Vue from "vue";
import "../assets/style/common.scss";
import NavBar from "@/components/layout/NavBar.vue";
import Layout from "@/components/layout/Layout.vue";
import Footer from "@/components/layout/Footer.vue";
import LeftRightContent from "@/components/layout/LeftRightContent.vue";

Vue.component("Layout", Layout);
Vue.component("NavBar", NavBar);
Vue.component("Footer", Footer);
Vue.component("LeftRightContent", LeftRightContent);
